import { Membership } from './subscriptions';

export const ORDERED_PLANS = [Membership.Bas, Membership.Plus, Membership.Standard];
